if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });

        // Handle default selected variant on page load
        if (this.dataset.defaultSelected === 'true') {
          document.addEventListener('page:loaded', () => {
            this.selectLastVariant();
          }, { once: true });
        }
      }

      selectLastVariant() {
        const firstOptionInput = this.querySelector('.product-form__input');
        if (!firstOptionInput) return;

        // Try radio inputs first (button/swatch/color pickers)
        const radioInputs = firstOptionInput.querySelectorAll('input[type="radio"]:not(.disabled):not([disabled])');
        if (radioInputs.length > 0) {
          const lastRadio = radioInputs[radioInputs.length - 1];
          if (lastRadio && !lastRadio.checked) {
            lastRadio.click();
          }
          return;
        }

        // Try dropdown selects
        const selectElement = firstOptionInput.querySelector('select');
        if (selectElement && selectElement.options.length > 0) {
          const lastOption = selectElement.options[selectElement.options.length - 1];
          if (lastOption && !lastOption.disabled && selectElement.value !== lastOption.value) {
            selectElement.value = lastOption.value;
            selectElement.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
